<div class="form-group row" *ngIf="show">
    <label class="col-form-label text-bold text-right mt-1 col-sm-8 pr-0" for="{{prefixName}}_add_auto_fix" translate>
        Add PageCorrect
    </label>
    <div class="col-sm-40 mt-1 pl-4 d-flex align-items-center">
        <form-field-material-switch name="{{prefixName}}_add_auto_fix"
                                    [(ngModel)]="canUse"
                                    (ngChange)="onChangeValue()">
        </form-field-material-switch>
    </div>
</div>